module.exports = __webpack_public_path__ + "img/685.4cccfe53.png";